import { postWithToken } from 'api/network';
import { put, takeEvery } from 'redux-saga/effects';
import {
  appNotify,
  createAssumptionModule,
  setModulesAreLoading,
  setSelectedModuleId,
  fetchAssumptionModules,
} from '../../../store/actions';

export function* createAssumptionModuleSaga() {
  yield takeEvery(createAssumptionModule, function* ({ payload }) {
    try {
      yield put(setModulesAreLoading(true));

      const url = '/api/assumptions/modules';
      const res = yield postWithToken(url, payload);
      const data = yield res.json();

      yield put(fetchAssumptionModules());
      yield put(setSelectedModuleId(data.moduleId));
      yield put(setModulesAreLoading(false));
      yield put(appNotify(`${payload.name} created`, 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to create assumption module: ${error.message}`, 'error')
      );
      yield put(setModulesAreLoading(false));
    }
  });
}
